import {AiOutlineInstagram} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
import { FaLinkedin } from "react-icons/fa";
import {AiFillGithub} from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://instagram.com', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://twitter.com/omonuj', icon: <AiOutlineTwitter/>},
    {id: 3, link: 'https://www.linkedin.com/in/odoh-jonah/', icon: <FaLinkedin/>},
    {id: 4, link: null, icon: <AiFillGithub/>}
]

export default data
